/**
 * Textos do card "Consorciados" do detalhe do grupo.
 *
 * O número é o "Número de consorciados" da Servopa, sem conta nossa — o sync
 * já grava o milhar certo (sync-browserless: numeroDeConsorciados). Sem o
 * número, "—": nunca 0 nem valor inventado.
 */
export const textoConsorciados = (n: number | null | undefined): string =>
  n == null || !Number.isFinite(n) ? '—' : n.toLocaleString('pt-BR');

/** "0 clientes North", "1 cliente North", "5 clientes North". */
export const textoClientesNorth = (n: number): string =>
  `${n.toLocaleString('pt-BR')} ${n === 1 ? 'cliente' : 'clientes'} North`;
